import { Link } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-slate-50 px-6 text-center">
      <p className="font-mono text-sm uppercase tracking-[0.3em] text-teal-600">
        Error 404
      </p>
      <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-900 sm:text-6xl">
        oh ho! page not found
      </h1>
      <p className="mt-4 max-w-md text-sm text-slate-500 sm:text-base">
        The page you're looking for doesn't exist, was moved, or the link is
        mistyped. Let's get you back on track.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-5 py-2.5
          text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800"
      >
        <LuArrowLeft size={16} />
        Back to home
      </Link>
    </div>
  );
}